<template>
    <v-container style="padding-top:70px">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-card class="mb-10">
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Listado de Categorías</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row class="mt-2" justify="center">
                            <v-col cols="12" md="2"><v-btn color="success" @click="nuevo()">
                                    <v-icon>
                                        mdi-plus-box-outline
                                    </v-icon>
                                </v-btn></v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                        <br />
                        <br />
                        <template v-if="items.length <= 3">
                            <v-row>
                                <v-col cols="12" md="4" v-for="(item, cfid2) in items" :key="cfid2">
                                    <v-card elevation="10" class="item-style" :class="validaestilo(cfid2)"
                                        :data-grid-groupkey="item.cfid2" width="100%">
                                        <v-card-title class="justify-center d-flex flex-nowrap">
                                            <v-icon class="pr-3" color="primary">{{ item.cficon }}</v-icon>
                                            <p class="text-h6 font-weight-bold"><span class="primary--text mr-2">{{
                                                item.cfnombre }}</span></p>
                                            <v-spacer></v-spacer>
                                            <v-menu>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon v-bind="attrs" v-on="on">
                                                        <v-icon color="greyTint">mdi-dots-vertical</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-item @click="Editar(item)" :disabled="disabled">
                                                        <v-list-item-title>Editar</v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item @click="AgregarReporte(item)" :disabled="disabled">
                                                        <v-list-item-title>Agregar Reporte</v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item @click="Eliminar(item)">
                                                        <v-list-item-title>Eliminar</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </v-card-title>
                                        <v-divider class="primary"></v-divider>
                                        <v-card-text>
                                            <v-row no-gutters class="pb-0">
                                                <v-col cols="12" class="my-auto">
                                                    <div v-for="(reporte, frid) in reportes" :key="frid">
                                                        <template v-if="reporte.cfid == item.cfid">
                                                            <vs-list-item :subtitle="reporte.asistencia">
                                                                <template #title>
                                                                    <button class="reporteindice ml-1"
                                                                        style="font-size: 20px; font-weight: 700;"
                                                                        @click="BuscarReporte(null, reporte)">{{
                                                                            reporte.reporte }}</button>
                                                                </template>
                                                                <v-btn icon @click="EliminarFav(reporte)">
                                                                    <v-icon color="#FF5C93">mdi-trash-can</v-icon>
                                                                </v-btn>
                                                            </vs-list-item>
                                                        </template>
                                                    </div>
                                                </v-col>
                                            </v-row>

                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </template>
                        <masonry-infinite-grid class="container" v-bind:gap="15" v-else>
                            <v-card elevation="10" class="item-style" v-for="(item, cfid2) in items" :key="cfid2"
                                :class="validaestilo(cfid2)" :data-grid-groupkey="item.cfid2">
                                <v-card-title class="justify-center d-flex flex-nowrap">
                                    <v-icon class="pr-3" color="primary">{{ item.cficon }}</v-icon>
                                    <p class="text-h6 font-weight-bold"><span class="primary--text mr-2">{{
                                        item.cfnombre }}</span></p>
                                    <v-spacer></v-spacer>
                                    <v-menu>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on">
                                                <v-icon color="greyTint">mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item @click="Editar(item)" :disabled="disabled">
                                                <v-list-item-title>Editar</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="AgregarReporte(item)" :disabled="disabled">
                                                <v-list-item-title>Agregar Reporte</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="Eliminar(item)">
                                                <v-list-item-title>Eliminar</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-card-title>
                                <v-divider class="primary"></v-divider>
                                <v-card-text>
                                    <v-row no-gutters class="pb-0">
                                        <v-col cols="12" class="my-auto">
                                            <div v-for="(reporte, frid) in reportes" :key="frid">
                                                <template v-if="reporte.cfid == item.cfid">
                                                    <vs-list-item :subtitle="reporte.asistencia">
                                                        <template #title>
                                                            <button class="reporteindice ml-1"
                                                                style="font-size: 20px; font-weight: 700;"
                                                                @click="BuscarReporte(null, reporte)">{{
                                                                    reporte.reporte }}</button>
                                                        </template>
                                                        <v-btn icon @click="EliminarFav(reporte)">
                                                            <v-icon color="#FF5C93">mdi-trash-can</v-icon>
                                                        </v-btn>
                                                    </vs-list-item>
                                                </template>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </masonry-infinite-grid>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog transition="dialog-bottom-transition" persistent v-model="dialog" max-width="600">
            <template>
                <v-card style="height: 350px !important;">
                    <v-toolbar color="primary" dark>{{ titulo }}</v-toolbar>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-form ref="form" v-model="valid" lazy-validation>
                                    <label class="typo__label" style="text-align: center;">Icono:</label>
                                    <multiselect v-model="icon"
                                        deselect-label="No se puede remover el valor seleccionado" label="icon"
                                        selected-label="Seleccionado" select-label="Seleccionar valor"
                                        placeholder="Seleccionar opción" :options="materialIcons" :allow-empty="false"
                                        :max-height="150">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <span class="option__title">
                                                    <v-icon color="success">{{ props.option.icon }}</v-icon>
                                                </span>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <span class="option__title">
                                                    <v-icon color="success">{{ props.option.icon }}</v-icon>
                                                </span>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <span style="color: #ff4081;" v-show="validaicon">campo requerido</span>
                                    <br />
                                    <label class="typo__label " style="text-align: center;">Nombre:</label>
                                    <v-text-field outlined dense :counter="100" maxlength="100"
                                        :rules="[rules.required, rules.counter, rules.text]"
                                        v-on:blur="nombre = nombre != null ? nombre.trim() : null" v-model="nombre">
                                    </v-text-field>
                                </v-form>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2" color="#536DFE" @click="Guardar()" style="color:white">
                                    Guardar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn class="ma-2" color="#FF5C93" @click="Limpiar2()" style="color:white">
                                    Cerrar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </template>
        </v-dialog>
        <v-dialog transition="dialog-bottom-transition" persistent v-model="dialog2" width="700">
            <template>
                <v-card>
                    <v-toolbar color="primary" dark>Agregar Reporte Nuevo</v-toolbar>
                    <v-card-text>
                        <v-card-text>
                            <div>
                                <v-row>
                                    <v-col cols="12" md="6" offset-md="3">
                                        <v-form ref="frm" v-model="valid2" lazy-validation>
                                            <label class="typo__label" style="text-align: center;">Buscar
                                                Reporte:</label>
                                            <v-text-field outlined dense :rules="[rules.required]"
                                                @keypress="filter($event)" v-model="reporte" maxlength="10">
                                            </v-text-field>
                                        </v-form>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" class="text-center">
                                        <v-btn class="ma-2" color="primary" @click="Buscar()">
                                            Buscar
                                            <template v-slot:loader>
                                                <span>Loading...</span>
                                            </template>
                                        </v-btn>
                                        <v-btn class="ma-2" color="default" @click="LimpiarReporte()">
                                            Limpiar
                                        </v-btn>
                                        <v-btn class="ma-2" color="error" @click="CerrarReporte()">
                                            Cerrar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                            <div v-if="verReporte">
                                <DataTable :url="urlListado" :columns="columns" :formatterActions="formatterActions"
                                    :order="[]" @apiDT="apiDT = $event" :params="displayInputs">
                                </DataTable>
                            </div>

                        </v-card-text>
                    </v-card-text>
                </v-card>
            </template>
        </v-dialog>
    </v-container>
</template>
<script>
import { mapState } from "vuex";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import General from '@/services/ReporteGeneral/ReporteGeneral.service.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
import { MasonryInfiniteGrid } from "@egjs/vue-infinitegrid";
import Operacion from "@/services/Operacion/Operacion.service.js";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
        Menu,
        MasonryInfiniteGrid
    },
    data: function () {
        return {
            validaicon: false,
            dialog: false,
            dialog2: false,
            user: '',
            ver: true,
            showcargando: true,
            valid: true,
            nombre: null,
            icon: '',
            id: '',
            total: 0,
            rules: {
                required: value => !!value || 'Campo requerido',
                counter: value => {
                    if (value == null || value == '') {
                        return true
                    }
                    else {
                        return value.length >= 3 || 'Minino 3 caracteres'
                    }
                },
                text: value => {
                    if (value == null || value == '') {
                        return true
                    }
                    else {
                        return value.length <= 100 || 'Máximo 100 caracteres'
                    }
                },
            },
            materialIcons: '',

            categoria: [],
            seleccion: {},
            titulo: 'Nueva Categoría',
            items: [],
            currentMaxBlogsOnScreen: [],
            disabled: false,
            /////////
            panel: [0, 1],
            disabled: false,
            readonly: false,
            itemcat: {},

            reportes: [],
            reporte: '',
            displayInputs: {},
            verReporte: false,
            urlListado: 'ReporteGeneral/BusquedaReportesFavoritos',
            columns: [
                { name: 'reporte', data: 'reporte', title: "Reporte", orderable: false, formatter: [this, "detalleReporte"], },
                { name: 'svfhreporte', data: 'svfhreporte', title: "Fecha Reporte", orderable: false },
                { name: 'ainombre', data: 'ainombre', title: "Asistencia", orderable: false },
                { name: 'clnombre', data: 'clnombre', title: "Cliente", orderable: false },
                { name: 'repo', data: 'reporte', title: "", formatter: [this, "GuardarReporte"], orderable: false },
            ],
            formatterActions: [
                { click: [this, "Favorito"] },
                { click: [this, "BuscarReporte"] },
            ],
            apiDT: null,
            valid2: true,
            perfil: {},
            cfid: 0,
            sending: false,
            valEditar: false,
        }
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    watch: {
        'icon': function () {
            if (this.icon != '')
                this.validaicon = false;
            else
                this.validaicon = true;
        }
    },
    methods: {
        validaestilo(index) {
            if (this.total.result == 2 && index == 1) {
                return 'item-style2';
            }
            else
                return '';
        },
        async Cerrar() {
            this.dialog2 = false;
        },

        async nuevo() {
            this.titulo = 'Nueva Categoría';
            this.icon = null;
            this.dialog = true;
            this.valEditar = false;
            let data = await General.ObtenerIcono();
            // Tu string con objetos JS
            var datos = data[0].Column1;

            // Reemplaza los nombres de propiedades para que tengan comillas
            var datosJson = datos.replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":');

            // Ahora puedes parsearlo como JSON
            var iconsArray = JSON.parse(datosJson);
            this.materialIcons = iconsArray;

            let frmdata = new FormData();
            frmdata.append("uslogin", this.user);
            let categorias = await General.ObtenerCategorias(frmdata);
            this.total = categorias.length;
            for (let index in categorias) {
                this.materialIcons = this.materialIcons.filter(item => item.icon != categorias[index].cficon);
            }
        },
        Limpiar2() {
            this.nombre = null;
            this.$refs.form.reset();
            this.validaicon = false;
            this.dialog = false;
        },
        async AgregarReporte(datos) {
            this.itemcat = datos;
            this.dialog2 = true;
            this.cfid = datos.cfid;
        },
        async Editar(item) {
            this.titulo = 'Editar Categoría';
            this.nombre = item.cfnombre;
            this.icon = {
                icon: item.cficon,
            };
            this.id = item.cfid;
            this.valEditar = true;
            this.dialog = true;
        },
        async Eliminar(item) {
            this.$swal({
                position: "center",
                icon: "info",
                text: "¿Está seguro que desea eliminar la categoría?, tiene reportes asignados",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar',
                allowEscapeKey: false,
                allowOutsideClick: false,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let formdata = new FormData();
                    formdata.append("id", item.cfid);
                    let data = await General.EliminarCategoria(formdata)
                    if (data.success) {
                        this.ObtenerCategoria();
                        this.$swal({
                            position: "center",
                            icon: "success",
                            text: "La categoría se eliminó correctamente",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showConfirmButton: true,
                            timer: 5000,
                        });
                    }
                    else {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            text: "Ocurrio un error, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showConfirmButton: true,
                            timer: 5000,
                        });
                    }
                }
            });
        },
        async Guardar() {
            if (this.icon == '' || this.icon == null)
                this.validaicon = true;
            if (this.$refs.form.validate() && !this.validaicon) {
                if (this.sending) { // Verifica si ya se está enviando
                    return; // Si es así, no hace nada
                }
                this.sending = true;
                let formdata = new FormData();
                formdata.append("uslogin", this.user);
                let data = await General.ObtenerCategorias(formdata);
                this.total = data.length;
                if (this.total >= 10 && this.id == '') {
                    this.$swal({
                        position: "center",
                        icon: "info",
                        tittle: 'Información',
                        text: "No se puede agregar más categorías, ha alcanzado el límite",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showConfirmButton: true,
                        timer: 5000,
                        confirmButtonText: "Aceptar",
                    });
                }
                else {
                    let formdata = new FormData();
                    formdata.append("nombre", this.nombre);
                    formdata.append("icon", this.icon.icon);
                    formdata.append("uslogin", this.user);
                    let data = await General.ValidacionCategorias(formdata);
                    data = this.valEditar == true ? false : data;
                    if (!data) {
                        this.$swal({
                            position: "center",
                            title: "Guardando, espere un momento...",
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            didOpen: async () => {
                                this.$swal.showLoading();
                                this.dialog = false;
                                if (this.id == '') {
                                    let data = await General.NuevaCategoria(formdata)
                                    if (data.success) {
                                        this.$swal({
                                            position: "center",
                                            icon: "success",
                                            title: "Éxito!",
                                            text: "La categoría se guardó correctamente",
                                            confirmButtonText: "Aceptar",
                                            showConfirmButton: true,
                                            allowOutsideClick: false,
                                            timer: 5000,
                                        }).then((result) => {
                                            this.Limpiar();
                                            this.ObtenerCategoria();
                                        });
                                    }
                                    else {
                                        this.$swal({
                                            position: "center",
                                            icon: "error",
                                            title: "Error!",
                                            html: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                            confirmButtonText: "Aceptar",
                                            showConfirmButton: true,
                                            allowEscapeKey: false,
                                            allowOutsideClick: false,
                                            timer: 5000,
                                        }).then((result) => {
                                            this.dialog = true;
                                        });
                                    }

                                } else {
                                    formdata.append("id", this.id);
                                    this.dialog = false;
                                    let data = await General.EditarCategoria(formdata);
                                    if (data.success) {
                                        this.$swal({
                                            position: "center",
                                            icon: "success",
                                            title: "Éxito!",
                                            text: "La categoría se modificó correctamente",
                                            confirmButtonText: "Aceptar",
                                            showConfirmButton: true,
                                            allowEscapeKey: false,
                                            allowOutsideClick: false,
                                            timer: 5000,
                                        }).then((result) => {
                                            this.Limpiar();
                                            this.ObtenerCategoria();
                                        });
                                    }
                                    else {
                                        this.$swal({
                                            position: "center",
                                            icon: "error",
                                            title: "Error!",
                                            html: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                            confirmButtonText: "Aceptar",
                                            showConfirmButton: true,
                                            allowEscapeKey: false,
                                            allowOutsideClick: false,
                                            timer: 5000,
                                        }).then((result) => {
                                            this.dialog = true;
                                        });
                                    }

                                }
                            }
                        })
                    } else {
                        this.$swal(
                            "Atención",
                            "Este icono ya fue utilizado en otra categoría, favor de verificar o cambiarlo.",
                            "info"
                        );
                    }
                }
                this.sending = false;
            }
        },
        Limpiar() {
            this.$refs.form.reset();
            this.icon = null;
            this.validaicon = false;
            this.id = '';
        },
        async ObtenerCategoria() {
            this.items = [];
            let formdata = new FormData();
            formdata.append("uslogin", this.user);
            let data = await General.ObtenerCategorias(formdata);
            this.total = data.length;
            this.items = data;
            this.currentMaxBlogsOnScreen = data;
            this.reportes = await General.Favoritos_ObtenerReportes(formdata);
            await this.getInitialItems(1, this.currentMaxBlogsOnScreen.length, null);
        },
        async getInitialItems(nextGroupKey, count, filter) {
            this.items = [];
            this.items = await this.getItems(nextGroupKey, count, filter);
        },
        async getItems(nextGroupKey, count, filter) {
            this.loadingNewPost = true;
            let nextItems = [];
            let cont = 0;
            await this.currentMaxBlogsOnScreen.forEach((element) => {
                const nextKey = nextGroupKey * count + cont;
                nextItems.push({ ...element, groupKey: nextGroupKey, key: nextKey });
                cont = cont + 1;
            });
            return nextItems;
        },
        async EliminarFav(datos) {
            this.$swal({
                position: "center",
                icon: "info",
                text: "¿Está seguro que desea eliminar el reporte de la Categoría?",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar',
                allowEscapeKey: false,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$swal({
                        position: "center",
                        title: "Eliminado, espere un momento...",
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: async () => {
                            this.$swal.showLoading();
                            let formdata = new FormData();
                            formdata.append("nrreporte", datos.nrreporte);
                            formdata.append("svindice", datos.svindice);
                            formdata.append("frid", datos.frid);
                            let data = await General.EliminarFavorito(formdata);
                            if (data.success) {
                                this.dialog = false;
                                this.ObtenerCategoria();
                                this.$swal({
                                    position: "center",
                                    icon: "success",
                                    title: "Éxito!",
                                    text: "Se eliminó el reporte de la categoría",
                                    confirmButtonText: "Aceptar",
                                    showConfirmButton: true,
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    timer: 5000,
                                });

                            }
                            else {
                                this.$swal({
                                    position: "center",
                                    icon: "error",
                                    title: "Error!",
                                    html: "No se puede Eliminar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                    confirmButtonText: "Aceptar",
                                    showConfirmButton: true,
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    timer: 5000,
                                }).then((result) => {

                                });
                            }
                        }
                    })
                }
            });
        },
        async BuscarReporte(params, item) {
            let url = '';
            let reporte = {
                nrreporte: item.nrreporte,
                svindice: item.svindice,
                aiclave: item.aiclave,
                svfhconclusion: item.svfhconclusion
            };

            await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
            let asistenciaurl = await MetodosGenerales.ObtenerURL(reporte);
            url = this.$router.resolve({ path: asistenciaurl + '/ReporteDetalle' });

            window.open(url.href, '_blank');
        },
        Buscar() {
            if (this.$refs.frm.validate()) {
                this.displayInputs = {
                    nrreporte: this.reporte,
                    uslogin: this.user,
                    perfil: this.perfil.perfil,
                    valor: this.perfil.valor,
                };
                this.verReporte = true;
            }

        },
        LimpiarReporte() {
            this.$refs.frm.reset();
            if (this.apiDT != null)
                this.apiDT.clear().draw();
        },
        CerrarReporte() {
            this.verReporte = false;
            this.$refs.frm.reset();
            this.apiDT = null;
            this.dialog2 = false;
        },
        filter: function (evt) {
            evt = (evt) ? evt : window.event;
            let expect = evt.target.value.toString() + evt.key.toString();

            if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async Favorito(params, datos, fila) {
            if (this.sending) { // Verifica si ya se está enviando
                return; // Si es así, no hace nada
            }
            this.sending = true; // Establece la variable de control en true
            this.categoria = null;
            this.validaicon = false;
            this.frid = datos.frid;
            this.reporte2 = datos.nrreporte;
            this.indice = datos.svindice;
            let formdata = new FormData();
            formdata.append("uslogin", this.user);
            formdata.append("nrreporte", this.reporte2);
            formdata.append("svindice", this.indice);
            formdata.append("cfid", this.cfid);
            let response = await General.ContadorFavorito(formdata)
            if (response.success && response.result[0].contador == 3) {
                this.$swal({
                    position: "center",
                    icon: "info",
                    title: "Advertencia!",
                    html: "El reporte alcanzó el máximo de 3 categorías que se puede asignar",
                    confirmButtonText: "Aceptar",
                    showConfirmButton: true,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    timer: 5000,
                }).then((result) => {

                });
            }
            else if (response.success && response.result[0].contador < 3 && response.result[0].existe == 1) {
                this.$swal({
                    position: "center",
                    icon: "info",
                    title: "Advertencia!",
                    html: "El reporte el reporte ya tiene asignado esta categoría",
                    confirmButtonText: "Aceptar",
                    showConfirmButton: true,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    timer: 5000,
                }).then((result) => {

                });
            }
            else if (response.success && response.result[0].contador < 3 && response.result[0].existe == 0) {
                await this.GuardarNuevo();
                this.verReporte = false;
            }
            else {
                this.$swal({
                    position: "center",
                    icon: "error",
                    title: "Error!",
                    html: "Ocurrió un error, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                    confirmButtonText: "Aceptar",
                    showConfirmButton: true,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    timer: 5000,
                }).then((result) => {

                });
            }

            // Al final del proceso, restablece las variables de control
            this.sending = false;
        },
        MostarCategorias(datos) {
            if (datos.frid != '')
                return `<span class="ma-2 v-chip theme--light v-size--default orange white--text" aria-haspopup="true" aria-expanded="false" style="align-self: center;"><span class="v-chip__content"><i aria-hidden="true" class="v-icon notranslate mdi ${datos.cficon} theme--light"></i></span></span>`;
            else
                return ``;
        },
        GuardarReporte(datos) {
            return `<div><button type="button" class="editar v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default success dt-formatterAction" data-action="0" data-params="${datos}" title="Asignar Categoría"><span class="v-btn__content"><i data-v-6d45dbae="" aria-hidden="true" class="v-icon notranslate mdi mdi-content-save-outline theme--light"></i></span></button></div>`;
        },
        detalleReporte(datos) {
            if ((datos.aiclave == 1 || datos.aiclave == 23 || datos.aiclave == 24 || datos.aiclave == 5 || datos.aiclave == 26 || datos.aiclave == 27)) {
                return `<button data-action="1" data-params="${datos.nrreporte}" class="dt-formatterAction ma-1 reporteindice">${datos.nrreporte}-${datos.svindice}</span></button>`;
            } else {
                return `<span>${datos.nrreporte}-${datos.svindice}</span>`;
            }
        },
        async GuardarNuevo() {
            this.$swal({
                position: "center",
                title: "Guardando, espere un momento...",
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: async () => {
                    this.$swal.showLoading();
                    let formdata = new FormData();
                    formdata.append("nrreporte", this.reporte2);
                    formdata.append("svindice", this.indice);
                    formdata.append("uslogin", this.user);
                    formdata.append("cfid", this.cfid);
                    let valida = await this.ValidaFavorito(formdata);
                    formdata.append("frid", 0);
                    if (valida) {
                        let data = await General.GuardarFavorito(formdata)
                        if (data.success) {
                            this.$refs.frm.reset();
                            this.apiDT.clear().draw();
                            this.dialog2 = false;
                            this.ObtenerCategoria();
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Éxito!",
                                text: "Se agregó el reporte a la categoría",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowEscapeKey: false,
                                allowOutsideClick: false,
                                timer: 5000,
                            }).then((result) => {
                                this.$refs.frm.reset();
                            });
                        }
                        else {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Error!",
                                html: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowEscapeKey: false,
                                allowOutsideClick: false,
                                timer: 5000,
                            }).then((result) => {

                            });
                        }
                    }
                    else {
                        this.$swal({
                            position: "center",
                            icon: "info",
                            title: "Atención",
                            html: "El reporte el reporte ya tiene asignado esta categoría",
                            confirmButtonText: "Aceptar",
                            showConfirmButton: true,
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            timer: 5000,
                        }).then((result) => {
                        });
                    }
                }
            })
        },
        async ValidaFavorito(data) {
            let dat = await General.ValidarReporteFavorito(data);
            if (dat.success == true) {
                if (dat.result[0].existe > 0) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }

        },
    },
        async mounted() {
        let data = await General.ObtenerIcono();
        // Tu string con objetos JS
        var datos = data[0].Column1;

        // Reemplaza los nombres de propiedades para que tengan comillas
        var datosJson = datos.replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":');

        // Ahora puedes parsearlo como JSON
        var iconsArray = JSON.parse(datosJson);
        this.materialIcons = iconsArray;

        this.user = await MetodosGenerales.ObtenerUserName();
        await this.ObtenerCategoria();
        await this.getInitialItems(0, this.total, null);
        let response = await Operacion.Perfil(this);
        this.perfil = response[0];

        this.ver = true;
        this.showcargando = false;
    },


}
</script>
<style scoped>
.main-buttons-container::-webkit-scrollbar {
    height: 0.4em;
    border-radius: 50%;
}

.main-buttons-container::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(165, 165, 165, 0.3);
}

.main-buttons-container::-webkit-scrollbar-thumb {
    background-color: rgb(155, 155, 155);
    outline: 1px solid rgb(177, 177, 177);
}

/* TODO: THIS SHOULD BE RESPONSIVE */
.item-style {
    min-width: 100%;
    width: 34.5%;
    max-width: 100%;
    padding: 10px 10px 10px 10px;
}

.item-style2 {
    position: absolute;
    top: 0px;
    /*left: 34% !important;*/
}

@media screen and (min-width: 900px) {
    .item-style {
        min-width: 49%;
        width: 32.5%;
        max-width: 100%;
        padding: 10px 10px 10px 10px;
    }

    .item-style2 {
        position: absolute;
        top: 0px;
        left: 50% !important;
    }
}

@media screen and (min-width: 1530px) {
    .item-style {
        min-width: 32.5%;
        width: 32.5%;
        max-width: 100%;
        padding: 10px 10px 10px 10px;
    }

    .item-style2 {
        position: absolute;
        top: 0px;
        left: 34% !important;
    }
}

#correo .list-titles {
    max-width: -webkit-fill-available !important;
}
</style>